import React, { useEffect, useRef } from 'react'
import './styles.scss'

const Input = ({
  label,
  name,
  value,
  onChange,
  formik,
  placeHolder,
  className,
  onBlur,
  autoComplete = '',
  noScroll,
  style,
  error,
  disabled = false,
  onlyNumber = false,
  isAdminLogin = false,
}) => {
  const fieldRef = React.useRef(null)

  useEffect(() => {
    if (
      !noScroll &&
      formik &&
      formik.touched[name] &&
      formik.errors[name] &&
      formik.isSubmitting &&
      fieldRef
    ) {
      return window.scrollTo({
        behavior: 'smooth',
        top: fieldRef.current.offsetTop + 100,
      })
    }
  }, [formik])
  const handleChange = (e) => {
    const val = e.target.value
    if (onlyNumber) {
      if (isAdminLogin) {
        if (val === '' || /^[0-9\b]+$/.test(val) || 'admin'.startsWith(val)) {
          onChange(e)
        }
      } else if (val === '' || /^[0-9\b]+$/.test(val)) {
        onChange(e)
      }
    } else {
      onChange(e)
    }
  }
  return (
    <div className={className}>
      {label && <div className="field__label">{label}</div>}
      <input
        style={style}
        ref={fieldRef}
        type="text"
        name={name}
        className={`field__input ${
          formik &&
          formik.touched[name] &&
          formik.errors[name] &&
          'form__input__error'
        } ${error ? 'form__input__error' : ''}`}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeHolder}
        onBlur={onBlur}
        autoComplete={autoComplete}
      />
      {formik && formik.touched[name] && formik.errors[name] && (
        <div className="form__error">{formik.errors[name]}</div>
      )}
    </div>
  )
}

export default Input
